import React from 'react';
import TimerComponent from '../../../resale/buyer/components/timer';

export default function Timer({config}) {
    return <TimerComponent minutesLabel='widget.resale.cart.min' secondsLabel='widget.resale.cart.sec' expiration_time={config?.timer_settings?.expiration_time} config={config}/>
}